Vue.component('v-invalid', {
  data: function () {
    return {
      fonts: ['sm', 'normal', 'lg'],
      colors: ['white', 'black', 'blue']
    }
  },
  mounted: function () {
    this.$actions.setInitialInvalidSettings()
  }
})
